import React, { Component } from 'react';
import { ErrorMessage, Field } from 'formik';
import { textFieldValidate } from './fieldValidateUtil';

class TextAreaWithoutTextEditor extends Component {
  validate = (value) => {
    return textFieldValidate(value, this.props.field, this.props.isConstructorForm);
  };

  render() {
    const { field } = this.props;
    return (
      <>
        <Field
          type="text"
          as="textarea"
          name={field.fieldName}
          className="form-control"
          validate={this.validate}
          placeholder={field.placeholder['en']}
          autoComplete="off"
          height="100px"
          width="200px"
          rows={1}
          title={field.fieldTitle['en']}
        />

        <p className="errors">
          <ErrorMessage name={field.fieldName} />
        </p>
      </>
    );
  }
}

export default TextAreaWithoutTextEditor;
